import Vue from "vue"

import { DateTime } from "luxon"
Object.defineProperty(Vue.prototype, "$DateTime", { value: DateTime })
